export default __webpack_public_path__ + "static/media/rfidScanner.32c5d6d6.svg";